import { Link } from "react-router-dom";
import { Truck, Route, Zap, PackageCheck, Network, ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/ui-bits";

const CARDS = [
  { number: "01", icon: Truck, title: "FTL & PARTIAL LOADS", desc: "Full and partial truckload transportation across Canada.", to: "/services#ftl-partial-loads", testid: "overview-card-1" },
  { number: "02", icon: Route, title: "DEDICATED TRANSPORTATION", desc: "Consistent capacity for recurring lanes and schedules.", to: "/services#dedicated", testid: "overview-card-2" },
  { number: "03", icon: Zap, title: "EXPEDITED & HOT SHOT", desc: "Direct transportation when timing matters.", to: "/services#expedite", testid: "overview-card-3" },
  { number: "04", icon: PackageCheck, title: "SPECIALIZED & WHITE-GLOVE DELIVERY", desc: "Additional handling and complete delivery support.", to: "/services#specialized", testid: "overview-card-4" },
  { number: "05", icon: Network, title: "3PL & FREIGHT BROKERAGE", desc: "Additional capacity through trusted carrier partners.", to: "/services#3pl", testid: "overview-card-5" },
];

const ServiceOverview = () => {
  return (
    <section data-testid="service-overview" aria-labelledby="overview-heading" className="border-t border-[#e5e7eb] bg-white pb-10 pt-16 sm:pb-12 sm:pt-20 lg:pb-12 lg:pt-24">
      <div className="container-30">
        <Reveal className="max-w-3xl">
          <Eyebrow>What We Do</Eyebrow>
          <h2
            id="overview-heading"
            data-testid="overview-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl"
          >
            ONE TRANSPORTATION PARTNER. THE RIGHT SOLUTION FOR THE SHIPMENT.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg">
            Every shipment has different requirements. 30 NORTH provides transportation solutions based on your
            freight, schedule and delivery needs, with additional transportation capacity available when required.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:mt-14 lg:grid-cols-5" data-testid="overview-cards">
          {CARDS.map((card, i) => (
            <Reveal key={card.number} delay={i * 0.06} className="h-full">
              <Link
                to={card.to}
                data-testid={card.testid}
                className="group flex h-full flex-col border border-[#e5e7eb] bg-white p-5 transition-all duration-300 hover:-translate-y-1 hover:border-[#191c1e] hover:shadow-[0_20px_40px_-24px_rgba(25,28,30,0.3)]"
              >
                <div className="flex items-center justify-between">
                  <card.icon className="h-5 w-5 text-[#ff6a00]" strokeWidth={1.75} aria-hidden="true" />
                  <span className="font-display text-lg font-extrabold text-[#191c1e]/20 transition-colors duration-300 group-hover:text-[#ff6a00]">
                    {card.number}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-sm font-bold leading-snug tracking-wide text-[#191c1e]">
                  {card.title}
                </h3>
                <p className="mt-2 flex-1 text-[13px] leading-relaxed text-[#5f666d]">{card.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-bold tracking-[0.14em] text-[#191c1e]/50 transition-colors duration-200 group-hover:text-[#ff6a00]">
                  VIEW SERVICE
                  <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOverview;
